import { withPlugins, eventBus, domEvents } from '@spon/plugins';

import Headroom from 'headroom.js';
import toggle from '@/utils/toggle';

function Header({ node, name, plugins: { addEvents } }) {
	const nav = toggle({
		button: node.querySelector('.o-burger'),
		name,
		activeClass: 'is-active',
	});
	nav.init();

	// function clickWhenOpenHandle({ target }) {
	// 	if (
	// 		target.id === 'header' ||
	// 		target.closest('#header') ||
	// 		target.hasAttribute('data-menu-opener-hero')
	// 	)
	// 		return; // Continue if clicking within #Header
	// 	nav.close();
	// }

	nav.on(`open:${name}`, ({ target }) => {
		node.classList.add('is-open');
		target.classList.add('is-open');

		eventBus.emit('menu:open');
		eventBus.emit('scroll:pause');

		// lock.capture();

		// document.addEventListener('click', clickWhenOpenHandle);
	});

	nav.on(`close:${name}`, ({ target }) => {
		node.classList.remove('is-open');
		target.classList.remove('is-open');

		eventBus.emit('menu:close');
		eventBus.emit('scroll:play');

		// lock.release();

		// document.removeEventListener('click', clickWhenOpenHandle);
	});

	eventBus.on('barba:enter', nav.close);
	// Main Mobile Menu END

	// Headroom
	const options = {
		offset: 120,
		tolerance: {
			up: 5,
			down: 0,
		},
	};
	const headroom = new Headroom(node, options);
	headroom.init();
	eventBus.on('menu:open', () => headroom.freeze());
	eventBus.on('menu:close', () => headroom.unfreeze());

	function openNavFromHomeHero() {
		// shouldLock = false;
		nav.open();
		// shouldLock = true;
	}

	function onKeyDown(event) {
		const { keyCode } = event;
		if (nav.isOpen && keyCode === 27) {
			nav.close();
		}
	}

	addEvents(document.body, {
		'click [data-menu-opener-hero]': openNavFromHomeHero,
		click: ({ target }) => {
			if (target.id === 'header' || target.closest('#header')) return;
		},
		keydown: onKeyDown,
	});
}

export default withPlugins(domEvents)(Header);
